// word 字号像素对应
//   八号＝5磅(5pt)＝(5/72)*96＝6.67＝6px

//   七号＝5.5磅＝(5.5/72)*96＝7.3＝7px

//   小六＝6.5磅＝(6.5/72)*96＝8.67＝8px

//   六号＝7.5磅＝(7.5/72)*96＝10px

//   小五＝9磅＝(9/72)*96＝12px

//   五号＝10.5磅＝(10.5/72)*96＝14px

//   小四＝12磅＝(12/72)*96＝16px

//   四号＝14磅＝(14/72)*96＝18.67＝18px

//   小三＝15磅＝(15/72)*96＝20px

//   三号＝16磅＝(16/72)*96＝21.3＝21px

//   小二＝18磅＝(18/72)*96＝24px

//   二号＝22磅＝(22/72)*96＝29.3＝29px

//   小一＝24磅＝(24/72)*96＝32px

//   一号＝26磅＝(26/72)*96＝34.67＝34px

//   小初＝36磅＝(36/72)*96＝48px

//   初号＝42磅＝(42/72)*96＝56px
const fontSizeMap = {
    '56px': '初号',
    '48px': '小初',
    '34px': '一号',
    '32px': '小一',
    '29px': '二号',
    '24px': '小二',
    '21px': '三号',
    '20px': '小三',
    '18px': '四号',
    '16px': '小四',
    '14px': '五号',
    '12px': '小五',
    '10px': '六号',
    '8px': '小六',
    '7px': '七号',
    '6px': '八号'
}

const fontSizeList = [
    { name: '初号', value: '56px' },
    { name: '小初', value: '48px' },
    { name: '一号', value: '34px' },
    { name: '小一', value: '32px' },
    { name: '二号', value: '29px' },
    { name: '小二', value: '24px' },
    { name: '三号', value: '21px' },
    { name: '小三', value: '20px' },
    { name: '四号', value: '18px' },
    { name: '小四', value: '16px' },
    { name: '五号', value: '14px' },
    { name: '小五', value: '12px' },
    { name: '六号', value: '10px' },
    { name: '小六', value: '8px' },
    { name: '七号', value: '7px' },
    { name: '八号', value: '6px' },
]

export { 
    fontSizeMap, 
    fontSizeList 
}
